import _ from 'lodash'
import {populatePerson, deletePeople, savePerson, doCsvUploadForPerson} from '../api'

export const loadPerson = ({ state, commit }, {uuid, loadDataFromServer}) => {
  if (loadDataFromServer || _.isEmpty(state.person)) {
    return populatePerson(uuid).then((response) => {
      console.log('in populatePerson: ', response)
      commit('LOAD_PERSON', response)
      return response
    })
  } else {
    commit('LOAD_PERSON', state.person)
    return state.person
  }
}

export const storePerson = ({ state, commit }, personObj) => {
  if (!personObj.uuid) {
    return
  }
  return savePerson(personObj).then((response) => {
    commit('LOAD_PERSON', response)
    return response
  })
}

export const deleteSelectedPersons = ({ state, commit }, uuids) => {
  return deletePeople(uuids).then(res => {
    return res
  })
}

export const uploadPersonCsvFile = ({ state, commit }, {institutionId, createdByUuid, folderId, fileData}) => {
  return doCsvUploadForPerson(institutionId, createdByUuid, folderId, fileData).then(res => {
    return res
  })
}



// WEBPACK FOOTER //
// ./src/app/person/vuex/actions.js